/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
    InsuranceTypeToJSONTyped,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface LeadPalInfoPayer
 */
export interface LeadPalInfoPayer {
    /**
     * 
     */
    insurance_id: string;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    payor_name: string;
    /**
     * 
     */
    insurance_type: InsuranceType;
    /**
     * 
     */
    coverage_priority: LeadPalInfoPayerCoveragePriorityEnum;
    /**
     * Null for payer types with no network concept (Medicare/Medicaid/ Private Pay).
     */
    network_status?: LeadPalInfoPayerNetworkStatusEnum | null;
    /**
     * Null when network_status isn't in_network (out-of-network and no-network-concept payers have no contract to speak of).
     */
    contract_status?: LeadPalInfoPayerContractStatusEnum | null;
}


/**
 * @export
 */
export const LeadPalInfoPayerCoveragePriorityEnum = {
    Primary: 'Primary',
    Secondary: 'Secondary',
    Tertiary: 'Tertiary',
} as const;
export type LeadPalInfoPayerCoveragePriorityEnum = typeof LeadPalInfoPayerCoveragePriorityEnum[keyof typeof LeadPalInfoPayerCoveragePriorityEnum];

/**
 * @export
 */
export const LeadPalInfoPayerNetworkStatusEnum = {
    InNetwork: 'in_network',
    OutOfNetwork: 'out_of_network',
} as const;
export type LeadPalInfoPayerNetworkStatusEnum = typeof LeadPalInfoPayerNetworkStatusEnum[keyof typeof LeadPalInfoPayerNetworkStatusEnum];

/**
 * @export
 */
export const LeadPalInfoPayerContractStatusEnum = {
    Available: 'available',
    Missing: 'missing',
    Error: 'error',
} as const;
export type LeadPalInfoPayerContractStatusEnum = typeof LeadPalInfoPayerContractStatusEnum[keyof typeof LeadPalInfoPayerContractStatusEnum];


/**
 * Check if a given object implements the LeadPalInfoPayer interface.
 */
export function instanceOfLeadPalInfoPayer(value: object): value is LeadPalInfoPayer {
    if (!('insurance_id' in value) || value['insurance_id'] === undefined) return false;
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('payor_name' in value) || value['payor_name'] === undefined) return false;
    if (!('insurance_type' in value) || value['insurance_type'] === undefined) return false;
    if (!('coverage_priority' in value) || value['coverage_priority'] === undefined) return false;
    return true;
}

export function LeadPalInfoPayerFromJSON(json: any): LeadPalInfoPayer {
    return LeadPalInfoPayerFromJSONTyped(json, false);
}

export function LeadPalInfoPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadPalInfoPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'insurance_id': json['insurance_id'],
        'payor_id': json['payor_id'],
        'payor_name': json['payor_name'],
        'insurance_type': InsuranceTypeFromJSON(json['insurance_type']),
        'coverage_priority': json['coverage_priority'],
        'network_status': json['network_status'] === undefined ? undefined : json['network_status'] === null ? null : json['network_status'],
        'contract_status': json['contract_status'] === undefined ? undefined : json['contract_status'] === null ? null : json['contract_status'],
    };
}

export function LeadPalInfoPayerToJSON(json: any): LeadPalInfoPayer {
    return LeadPalInfoPayerToJSONTyped(json, false);
}

export function LeadPalInfoPayerToJSONTyped(value?: LeadPalInfoPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insurance_id': value['insurance_id'],
        'payor_id': value['payor_id'],
        'payor_name': value['payor_name'],
        'insurance_type': InsuranceTypeToJSON(value['insurance_type']),
        'coverage_priority': value['coverage_priority'],
        'network_status': value['network_status'],
        'contract_status': value['contract_status'],
    };
}

